import {NgModule} from '@angular/core';
import {ModelModule} from './model/model.module';

/**
 * Created by Rodrigo Quesada on 09/12/16.
 */
@NgModule({
    imports: [ModelModule]
})
export class DomainModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/domain.module.ts